<template>

  <div>
    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="loading_page" v-if="loading">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
      </div>
      <div class="m-2">
     
        <drainge-plan-form
            :on-submit="onSubmit"
            
            :plan-data="planData"
            
            :errors="errors">
        </drainge-plan-form>
      </div>
    </b-card>
    <b-row>
      <b-col cols="12" class="mt-5">
        <b-card no-body class="mb-0">
        <b-row>
          <b-col  cols="4">
            <CollapseableTimeLine  :params="{commentable:'plan',commentable_id:$route.params.id}"  class="mt-5"/>
          </b-col>
        </b-row>
        </b-card>
      
     </b-col>
    </b-row>
    
  </div>

</template>

<script>

import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BFormInvalidFeedback,
  BBadge, BDropdown, BDropdownItem, BPagination, BForm,BFormGroup, BFormCheckboxGroup
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import {computed, onUnmounted, ref, watch} from '@vue/composition-api'
import store from '@/store'

import { PlanStore } from "@/app/plans/drainage/state";

import flatPickr from 'vue-flatpickr-component'
import Ripple from "vue-ripple-directive"
import DraingePlanForm from '@/views/modules/plans/drainage-plan/share/DrainagePlanForm'
import router from '@/router'
import CollapseableTimeLine from '@core/components/app-timeline/CollapseableTimeLine.vue'
export default {
  components: {
    OrbitSpinner,flatPickr,BFormInvalidFeedback,
    BCard, BRow, BCol, BFormInput, BButton, BTable,BFormCheckboxGroup,
    BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination,
    vSelect, BForm, BFormGroup,
    DraingePlanForm,CollapseableTimeLine
  },
  directives: {
    Ripple,
  },

  setup(props, {root}) {


    // Register module
    if (!store.hasModule('plans'))
      store.registerModule('plans', PlanStore)


    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule('plans'))
        store.commit('plans/RESET_STORE_DATA')
        store.unregisterModule('plans')
    })


    


    const planData = computed(() => store.state.plans.data)
    const errors = computed(() => store.state.plans.errors)
    const loading = computed(() => store.state.plans.loading)

    store.dispatch('plans/getPlan', router.currentRoute.params.id).then(res => {
     
    
    })

    const onSubmit = () => {

      store.dispatch('plans/updatePlan', router.currentRoute.params.id).then(res => {
        root.$bvToast.toast(root.$t('drainage plan updated successfully'), {
          title: root.$t("success"),
          variant: 'success',
          solid: false,
        })
      }).catch(reason => {
        root.$bvToast.toast(root.$t(reason), {
          title: root.$t("Error"),
          variant: 'danger',
          solid: false,
        })
      })
    
    }


    return {
     
      onSubmit,
      loading,
      planData,
      errors,
    }

  }

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.per-page-selector {
  width: 90px;
}
.actionIcon > button {
  padding: 0;
}
</style>
